import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITruncateString from 'UIComponents/text/UITruncateString';
import Small from 'UIComponents/elements/Small';
import { CALYPSO } from 'HubStyleTokens/colors'; // @ts-expect-error module is untyped

import MobilePanel from 'ecosystem-marketplace-core/js/components/mobile/MobilePanel';
import MobilePanelBody from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelBody';
import MobilePanelHeader from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelHeader';
import MobilePanelNavItem from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelNavItem';
const StyledHeaderAction = styled(UIButton).withConfig({
  displayName: "MobileFilterFieldPanel__StyledHeaderAction",
  componentId: "sc-1is88jr-0"
})(["&&&&{padding:4px;}"]);

function NavItemTitle({
  title,
  subtitle
}) {
  return /*#__PURE__*/_jsxs("div", {
    children: [title, /*#__PURE__*/_jsx("br", {}), subtitle && /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: subtitle
      })
    })]
  });
}

export default function MobileFilterFieldPanel({
  children,
  header,
  onApply,
  title,
  subtitle
}) {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  if (!header) header = title;
  return /*#__PURE__*/_jsx(MobilePanelNavItem, {
    onClickItem: () => setIsPanelOpen(true),
    title: /*#__PURE__*/_jsx(NavItemTitle, {
      title: title,
      subtitle: subtitle
    }),
    children: /*#__PURE__*/_jsxs(MobilePanel, {
      open: isPanelOpen,
      children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
        itemLeft: /*#__PURE__*/_jsxs(StyledHeaderAction, {
          className: "m-left-2",
          use: "transparent",
          onClick: () => setIsPanelOpen(false),
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "left",
            color: CALYPSO,
            size: "xs"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.themes.filterPanel.back"
          })]
        }),
        itemRight: /*#__PURE__*/_jsx(StyledHeaderAction, {
          className: "m-right-3",
          use: "transparent",
          onClick: () => onApply(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.themes.filterPanel.apply"
          })
        }),
        title: header
      }), /*#__PURE__*/_jsx(MobilePanelBody, {
        className: "p-x-6 p-y-2",
        children: children
      })]
    })
  });
}